<div class="d-flex justify-content-between">
  <!--Delete-->
  @if (editBtnVisible) {
    <button
      type="button"
      class="btn btn-outline-warning btn-sm ag_grid_row_btn form-control py-0"
      style="margin-left: 2px; margin-right: 2px"
      placement="left"
      (click)="editClick()"
      >
      <i class="fa-solid fa-eye"></i> / <i class="fa-solid fa-pen"></i>
    </button>
  }
</div>
